import {
  getDoc,
  doc,
  serverTimestamp,
  addDoc,
  collection,
  query,
  startAfter,
  limit,
  getDocs,
  orderBy,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "../config/fbConfig";

const usersCollectionRef = collection(db, "users");

export const fetchUserById = async (userId) => {
  const docRef = doc(db, "users", userId);
  const user = await getDoc(docRef);
  if (user && !!user.data()) {
    return user.data();
  }
  return null;
};

export const createUserWithScore = async (userDetails) => {
  userDetails["createdAt"] = serverTimestamp();
  return await addDoc(usersCollectionRef, userDetails);
};



export const getUsersViaPagination = async (
  startFromDoc,
  prevPageDoc,
  dataLimit,
  getPrevPage
) => {
  let userQuery = query(
    usersCollectionRef,
    orderBy("score", "desc"),
    limit(dataLimit)
  );
  if (!!startFromDoc) {
    userQuery = query(
      usersCollectionRef,
      orderBy("score", "desc"),
      startAfter(startFromDoc),
      limit(dataLimit)
    );
  }
  if (!!startFromDoc && !!prevPageDoc && getPrevPage) {
    userQuery = query(
      usersCollectionRef,
      orderBy("score", "desc"),
      startAfter(prevPageDoc),
      limit(dataLimit)
    );
  }
  return await getDocs(userQuery);

};

export const getScoresCount = async () => {
  const snapshot = await getCountFromServer(usersCollectionRef);
  return snapshot.data().count;
};

export const getAllUsers = async () => {
  const userQuery = query(usersCollectionRef, orderBy("score", "desc"));
  return (await getDocs(userQuery)).docs.map((user) => user.data());
};
